export const INPUT_STATS_LEVELS = {
  overall: [
    { label: 'Programme', value: 'programme' },
    { label: 'Service Provider', value: 'serviceProvider' },
    { label: 'Intervention', value: 'intervention' },
  ],
  detailed: [
    { label: 'Programme', value: 'programme' },
    { label: 'Service Provider', value: 'serviceProvider' },
    { label: 'Intervention', value: 'intervention' },
    { label: 'Activity', value: 'activity' },
  ],
};

export const OVERALL_PROGRAMME_STATS = [
  { label: 'Programme ID', key: 'programmeId' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Budgeted Amount', key: 'overallBudgetedAmount' },
  { label: 'Received Amount', key: 'overallReceivedAmount' },
  { label: 'Spend Amount', key: 'overallSpentAmount' },
  { label: 'Overall Time (hrs)', key: 'overallTime' },
  { label: 'Treatment Time (hrs)', key: 'overallTreatmentTime' },
];

export const OVERALL_SERVICE_PROVIDER_STATS = [
  { label: 'Service Provider ID', key: 'serviceProviderId' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Budgeted Amount', key: 'overallBudgetedAmount' },
  { label: 'Received Amount', key: 'overallReceivedAmount' },
  { label: 'Spend Amount', key: 'overallSpentAmount' },
  { label: 'Overall Time (hrs)', key: 'overallTime' },
  { label: 'Treatment Time (hrs)', key: 'overallTreatmentTime' },
];

export const OVERALL_INTERVENTION_STATS = [
  { label: 'Intervention ID', key: 'interventionId' },
  { label: 'Intervention', key: 'interventionName' },
  { label: 'Budgeted Amount', key: 'overallBudgetedAmount' },
  { label: 'Received Amount', key: 'overallReceivedAmount' },
  { label: 'Spend Amount', key: 'overallSpentAmount' },
  { label: 'Overall Time (hrs)', key: 'overallTime' },
  { label: 'Treatment Time (hrs)', key: 'overallTreatmentTime' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'School Subject', key: 'subjectName' },
  { label: 'Other Subject', key: 'focusSubjectNames' },
  { label: 'Grade', key: 'gradeValues' },
  { label: 'Class', key: 'class' },
  { label: 'Start Date', key: 'interventionFromDate' },
  { label: 'End Date', key: 'interventionToDate' },
];

export const DETAILED_PROGRAMME_STATS = [
  { label: 'Programme ID', key: 'programmeId' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Input Category', key: 'category.name' },
  { label: 'Input Type', key: 'type.name' },
  { label: 'Description', key: 'description' },
  { label: 'Total Quantity', key: 'quantity' },
  { label: 'Distributed', key: 'distributed' },
  { label: 'Retrieved', key: 'retrieved' },
  { label: 'Utilisation Tracking', key: 'utilizationTracking' },
  { label: 'Frequency', key: 'frequencyInt' },
];

export const DETAILED_SERVICE_PROVIDER_STATS = [
  { label: 'Service Provider ID', key: 'serviceProviderId' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Input Category', key: 'category.name' },
  { label: 'Input Type', key: 'type.name' },
  { label: 'Description', key: 'description' },
  { label: 'Total Quantity', key: 'quantity' },
  { label: 'Distributed', key: 'distributed' },
  { label: 'Retrieved', key: 'retrieved' },
  { label: 'Utilisation Tracking', key: 'utilizationTracking' },
  { label: 'Frequency', key: 'frequencyInt' },
];

export const DETAILED_INTERVENTION_STATS = [
  { label: 'Intervention ID', key: 'intervention.id' },
  { label: 'Intervention', key: 'intervention.name' },
  { label: 'Input Category', key: 'category.name' },
  { label: 'Input Type', key: 'type.name' },
  { label: 'Description', key: 'description' },
  { label: 'Total Quantity', key: 'quantity' },
  { label: 'Distributed', key: 'distributed' },
  { label: 'Retrieved', key: 'retrieved' },
  { label: 'Utilisation Tracking', key: 'utilizationTracking' },
  { label: 'Frequency', key: 'frequencyInt' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'School Subject', key: 'intervention.subject.name' },
  { label: 'Other Subject', key: 'intervention.focusSubjectNames' },
  { label: 'Grade', key: 'intervention.gradeValues' },
  { label: 'Class', key: 'intervention.class' },
  { label: 'Start Date', key: 'interventionFromDate' },
  { label: 'End Date', key: 'interventionToDate' },
];

export const DETAILED_ACTIVITY_STATS = [
  { label: 'Intervention ID', key: 'intervention.id' },
  { label: 'Intervention', key: 'intervention.name' },
  { label: 'Activity Name', key: 'activityName' },
  { label: 'Input Category', key: 'category.name' },
  { label: 'Input Type', key: 'type.name' },
  { label: 'Description', key: 'description' },
  { label: 'Total Quantity', key: 'quantity' },
  { label: 'Distributed', key: 'distributed' },
  { label: 'Retrieved', key: 'retrieved' },
  { label: 'Utilisation Tracking', key: 'utilizationTracking' },
  { label: 'Frequency', key: 'frequencyInt' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Intervention ID', key: 'intervention.id' },
  { label: 'Intervention', key: 'intervention.name' },
  { label: 'School Subject', key: 'intervention.subject.name' },
  { label: 'Other Subject', key: 'intervention.focusSubjectNames' },
  { label: 'Grade', key: 'intervention.gradeValues' },
  { label: 'Class', key: 'intervention.class' },
  { label: 'Start Date', key: 'interventionFromDate' },
  { label: 'End Date', key: 'interventionToDate' },
];

export const inputStatsVisibleOptions = {
  overall: {
    programme: ['programme'],
    serviceProvider: ['programme', 'serviceProvider'],
    intervention: ['programme', 'serviceProvider', 'intervention'],
  },
  detailed: {
    programme: ['programme'],
    serviceProvider: ['programme', 'serviceProvider'],
    intervention: ['programme', 'serviceProvider', 'intervention'],
    activity: ['programme', 'serviceProvider', 'intervention', 'activity'],
  },
};

export const inputStatsSelectOptions = {
  overall: {
    programme: OVERALL_PROGRAMME_STATS,
    serviceProvider: OVERALL_SERVICE_PROVIDER_STATS,
    intervention: OVERALL_INTERVENTION_STATS,
  },
  detailed: {
    programme: DETAILED_PROGRAMME_STATS,
    serviceProvider: DETAILED_SERVICE_PROVIDER_STATS,
    intervention: DETAILED_INTERVENTION_STATS,
    activity: DETAILED_ACTIVITY_STATS,
  },
};
